/*global Clipboard:readonly*/

angular.module('b2bLoginApp.controllers').controller('WidgetDetailsController', ["$scope", "$uibModal", "$sce", "$timeout", "$http", function ($scope, $uibModal, $sce, $timeout, $http) {
    $scope.openModal = function () {
        $uibModal.open({
            templateUrl: '/account/company-profile-public/widget-details-modal.html',
            backdrop: 'static',
            scope: $scope
        });
    }

    $scope.$watchGroup(['domain', 'data.profile.hash'], function (newValues) {
        if (newValues[0] && newValues[1]) {
            $scope.embededWidgetLink = $scope.domain + "/pro/" + $scope.data.profile.hash + "/rating-widget.html";
            $scope.widgetCopyLink = '<div id="sd-company-profile-rating-widget" data-src="' + $scope.domain + '/pro/' + $scope.data.profile.hash + '/rating-widget.html"></div><script type="text/javascript" src="' + $scope.domain + '/build/js/components/company-profile-widget.js" defer></script>';
            getWidgetHtml($scope.embededWidgetLink)
        }
    });

    activate();

    function activate() {
        var clipboard = new Clipboard('#widgetCopyButton');

        clipboard.on('success', function () {
            $scope.$apply(function () {
                $scope.copied = true;
                $timeout(function () {
                    $scope.copied = false;
                }, 5000);
            });

        });
    }

    function getWidgetHtml(embededWidgetLink) {
        $http.get(embededWidgetLink).then(response => {
            $scope.widgetHTML = $sce.trustAsHtml(response.data);
        });
    }
}]);
